function filterContactFormLocations() {
  const stateSelect = document.querySelector("select[name='states']")
  const locationsSelect = document.querySelector("select[name='locations']")
  let locationsSelectOptgroup
  // Mailchimp specific input field for the location name
  const selectedLocation = document.querySelector('#mce-MMERGE15')

  if (stateSelect == null || locationsSelect == null) {
    return
  }

  locationsSelectOptgroup = locationsSelect.querySelectorAll('optgroup')

  // Add an event listener to the states select box
  stateSelect.addEventListener('change', e => {
    // Grab the selected value
    const selectedValue = e.target.value

    // If the selected option has a value, run the code
    if (selectedValue !== '') {
      // Initially make all the option groups inside the locations select box hidden
      locationsSelectOptgroup.forEach(optgroup => {
        optgroup.style.display = 'none'
      })

      // If the selected state matches a location group, which is grouped by state,
      // only display that option group inside the locations select box
      locationsSelectOptgroup.forEach(optgroup => {
        if (selectedValue === optgroup.label) {
          optgroup.style.display = 'block'
        }
      })

      return
    }

    // Else, if the selected state value is empty, ie "Select state", display all of
    // the location option groups inside the locations select box
    locationsSelectOptgroup.forEach(optgroup => {
      optgroup.style.display = 'block'
    })
  })

  // Add an event listener to the locations select box to update the Mailchimp input field for the location name
  locationsSelect.addEventListener('change', e => {
    const selectedValue = e.target.value

    // If the selected item has an empty value, ie "Select a location", make sure the Mailchimp input field is also empty
    if (selectedValue === '') {
      selectedLocation.value = ''

      return
    }

    // If a location is selected, update the Mailchimp input field with the location's name
    selectedLocation.value = e.target.value
  })
}

export default function init() {
  filterContactFormLocations()
}



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/pages/contactForm.js